import React, { useEffect } from "react";
import AOS from "aos";
import MobileHero from "../../assets/service/mobile-application-hero.png";
import MobileApp from "../../assets/service/mobile-application.png";
import "aos/dist/aos.css";
import BgImg from "../../assets/portfolio/bg2.png";
import ServiceSide from "./ServiceSide";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMobileAlt,
  faCode,
  faLock,
  faTachometerAlt,
} from "@fortawesome/free-solid-svg-icons";
import MobileApplicationFaq from "../ServiceImp/MobileApplicationFaq";
import { Helmet } from "react-helmet-async";
const MobileApplication = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true }); // Initialize AOS with animation duration and animation trigger once
  }, []);

  const pillars = [
    {
      icon: faMobileAlt, // Icon for User Experience (UX) & UI Design
      title: "User Experience (UX) & UI Design",
      description:
        "Creates intuitive, user-friendly interfaces with seamless navigation.",
      bgColor: "bg-green-100", // Background color for this pillar
    },
    {
      icon: faTachometerAlt, // Icon for Performance & Scalability
      title: "Performance & Scalability",
      description:
        "Ensures fast performance and the ability to scale as your app grows.",
      bgColor: "bg-blue-100", // Background color for this pillar
    },
    {
      icon: faLock, // Icon for Security & Data Protection
      title: "Security & Data Protection",
      description:
        "Protects user data with encryption and secure authentication.",
      bgColor: "bg-purple-100", // Background color for this pillar
    },
    {
      icon: faCode, // Icon for Cross-Platform Compatibility & Integration
      title: "Platform Compatibility & Integration",
      description:
        "Supports iOS, Android, and integrates with third-party systems.",
      bgColor: "bg-orange-100", // Background color for this pillar
    },
  ];
  // seo data
  const schemas = [
    {
      "@context": "http://schema.org",
      "@type": "Organization",
      name: "Deetya Soft Pvt Ltd",
      description:
        "Boost your business with customized Android & iOS mobile apps. Deetyasoft offers scalable, user-friendly mobile app development for all industries.",
      image:
        "https://deetyasoft.com/static/media/mobile-application.889ba73e6e14fbf64443.png",
      logo: "https://www.deetyasoft.com/images/logo.png",
      url: "https://www.deetyasoft.com",
      telephone: ["+91-9015350505", "+91-9717055088"],
      email: "info@deetyasoft.com",
      sameAs: [
        "https://www.linkedin.com/company/deetya-soft-private-limited",
        "https://www.facebook.com/deetyasoftprivatelimited",
        "https://www.instagram.com/deetyasoft",
        "https://www.youtube.com/@deetyasoft",
        "https://www.crunchbase.com/organization/deetyasoft",
      ],
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "FF‑06, First Floor, Mahaluxmi Square, Plot No. C‑1, Abhay Khand II, Indirapuram",
        addressLocality: "Ghaziabad",
        addressRegion: "Uttar Pradesh",
        postalCode: "201014",
        addressCountry: "IN",
      },
    },
    {
      "@context": "http://schema.org",
      "@type": "Organization",
      url: "https://www.deetyasoft.com",
      contactPoint: [
        {
          "@type": "ContactPoint",
          telephone: "+91-981-862-7588",
          contactType: "technical support",
          areaServed: "IN",
        },
        {
          "@type": "ContactPoint",
          telephone: "+91-901-535-0505",
          contactType: "sales",
          areaServed: "IN",
        },
      ],
    },
    {
      "@context": "http://schema.org",
      "@type": "Review",
      author: {
        "@type": "Person",
        name: "Parshan",
      },
      reviewBody:
        "Deetya Soft helps companies to enable effective business operations through custom web solutions, IVR, and cloud telephony services.",
      url: "https://www.deetyasoft.com/",
      description:
        "Deetya Soft Pvt Ltd offers services such as IVR systems, virtual phone numbers, toll-free numbers, call tracking, enquiry management, LMS, web solutions, VOIP, and cloud-based communication solutions.",
      datePublished: "2025-06-17",
      name: "Deetya Soft Pvt Ltd",
      reviewRating: {
        "@type": "Rating",
        worstRating: "1",
        ratingValue: "5",
        bestRating: "5",
      },
      itemReviewed: {
        "@type": "Organization",
        name: "Deetya Soft Pvt Ltd",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What is mobile app development?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Mobile app development is the process of creating software applications that run on mobile devices such as smartphones and tablets. These apps are designed to provide functionality and improve user experience.",
          },
        },
        {
          "@type": "Question",
          name: "Why should I develop a mobile app for my business?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "A mobile app can improve customer engagement, enhance user experience, and offer more direct communication channels, all while providing a seamless service on-the-go for your customers.",
          },
        },
        {
          "@type": "Question",
          name: "What platforms can I develop my mobile app on?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You can develop mobile apps for iOS, Android, or both, depending on your target audience and business needs. Cross-platform solutions like React Native and Flutter allow development for both platforms simultaneously.",
          },
        },
        {
          "@type": "Question",
          name: "How do mobile apps enhance customer experience?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Mobile apps provide personalized experiences, faster access to services, and seamless interactions, such as push notifications, location-based features, and offline capabilities, improving user satisfaction and retention.",
          },
        },
      ],
    },
  ];
  return (
    <>
      <Helmet>
        <title>Mobile App Development Services | Deetyasoft</title>
        <meta
          name="description"
          content="Boost your business with customized Android & iOS mobile apps. Deetyasoft offers scalable, user-friendly mobile app development for all industries."
        />
        <meta
          name="keywords"
          content="mobile app development company, Android app development, iOS app development, custom mobile apps, Deetyasoft, mobile app, app development"
        />
        <link
          rel="canonical"
          href="https://deetyasoft.com/mobile-application-services"
        />

        {/* <!-- Facebook Meta Tags --> */}
        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content="https://deetyasoft.com/mobile-application-services"
        />
        <meta
          property="og:title"
          content="Mobile App Development Services | Deetyasoft"
        />
        <meta
          property="og:description"
          content="Boost your business with customized Android & iOS mobile apps. Deetyasoft offers scalable, user-friendly mobile app development for all industries."
        />
        <meta
          property="og:image"
          content="https://deetyasoft.com/static/media/mobile-application.889ba73e6e14fbf64443.png"
        />
        <meta property="og:site_name" content="deetyasoft.com" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/deetyasoftprivatelimited"
        />

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:url"
          content="https://deetyasoft.com/mobile-application-services"
        />
        <meta
          name="twitter:title"
          content="Mobile App Development Services | Deetyasoft"
        />
        <meta
          name="twitter:description"
          content="Boost your business with customized Android & iOS mobile apps. Deetyasoft offers scalable, user-friendly mobile app development for all industries."
        />
        <meta
          name="twitter:image"
          content="https://deetyasoft.com/static/media/mobile-application.889ba73e6e14fbf64443.png"
        />
        <meta name="twitter:site" content="@DeetyaSoft" />
        <meta name="twitter:creator" content="@DeetyaSoft" />

        <meta name="yandex-verification" content="31c730ea93a5a9cd" />
        <meta name="copyright" content="Deetyasoft" />
        <meta name="author" content="Deetyasoft" />
        <meta name="email" content="info@deetyasoft.com" />
        <meta name="Distribution" content="Global" />
        <meta name="rating" content="general" />
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta property="bingbot" content="index, follow " />
        <meta name="Yahoobot" content="index, follow" />
        <meta name="MSNbot" content="index, follow" />
        <meta name="googlebot-news" content="index, follow" />
        <meta name="audience" content="all" />
        <meta name="geo.placename" content="Noida, Uttar Pradesh, India" />
        <meta name="geo.region" content="IN-UP" />
        <meta name="geo.position" content="28.644800;77.373300" />
        <meta name="ICBM" content="28.644800, 77.373300" />
        <link rel="alternate" href="https://deetyasoft.com" hreflang="en-us" />
        <meta http-equiv="content-language" content="en-us" />
        <meta name="msvalidate.01" content="305155CCD42FD63B0A29555BBEE7CA03" />

        {/* <!-- Id+json scripts --> */}
        {schemas.map((schema, index) => (
          <script
            key={index}
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
          />
        ))}
      </Helmet>

      <div className="relative bg-[#2f68a2] overflow-hidden pb-5 text-white">
        {/* Content */}
        <div className="relative z-20 max-w-7xl mx-auto  px-6 py-10 grid md:grid-cols-2 lg:gap-20 md:gap-10  items-start">
          {/* Left Side */}
          <div>
            <h1 className="text-3xl md:text-4xl font-bold leading-snug mb-4">
              Mobile Application
            </h1>
            <p className="text-white/90 mb-6 text:base md:text-lg">
              We offer a wide range of web solutions tailored to your business
              needs. From designing modern, responsive websites to implementing
              advanced web technologies, we ensure your online presence is
              impactful and user-friendly. Our team is committed to delivering
              scalable and future-ready digital experiences that drive results.
            </p>
            {/* <button className="bg-orange-500 hover:bg-orange-600 text-white px-5 py-3 rounded shadow-md transition">
              Let's Get Started
            </button> */}
            <button
              className="bg-orange-500   hidden md:block hover:bg-orange-600 text-white px-5 py-3 rounded shadow-md transition"
              onClick={() => {
                const target = document.getElementById("bottomTarget");
                if (target) {
                  target.scrollIntoView({ behavior: "smooth", block: "start" });
                  // Optional offset tweak using window.scrollBy
                  setTimeout(() => {
                    window.scrollBy(0, -100); // scrolls 100px up after reaching the section
                  }, 600);
                }
              }}
            >
              Let's Get Started
            </button>
          </div>

          {/* Right Side Image */}
          <div className="flex justify-center">
            <img
              src={MobileHero}
              alt="SEO Illustration"
              className="md:w-[90%] object-contain w-full max-w-lg animate-float"
            />
          </div>
        </div>

        {/* FIRST CURVE - White */}
        <div className="absolute bottom-0 left-0 w-full z-10">
          <svg
            className="w-full h-auto"
            viewBox="0 0 1440 320"
            preserveAspectRatio="none"
          >
            <path
              fill="#ffffff"
              fillOpacity="1"
              d="M0,160L60,165.3C120,171,240,181,360,165.3C480,149,600,107,720,117.3C840,128,960,192,1080,208C1200,224,1320,192,1380,176L1440,160L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
            />
          </svg>
        </div>

        {/* SECOND CURVE - Light Blue */}
        <div className="absolute bottom-[20px] left-0 w-full z-0">
          <svg
            className="w-full h-auto"
            viewBox="0 0 1440 320"
            preserveAspectRatio="none"
          >
            <path
              fill="#a6c7e2" // Light blue like in the image
              fillOpacity="1"
              d="M0,288L60,272C120,256,240,224,360,197.3C480,171,600,149,720,160C840,171,960,213,1080,208C1200,203,1320,149,1380,122.7L1440,96L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
            />
          </svg>
        </div>
      </div>

      {/* second section is here */}

      <div className="">
        <h2 className="text-xl px-2 md:px-0 md:text-3xl font-bold text-center  mb-2 text-gray-600">
          Mobile Application
        </h2>
        <div className="md:w-40 w-20 h-1 bg-main mx-auto md:mb-3 mb-1 rounded-full" />

        <p className="text-center text-gray-700 px-4 md:px-20 lg:px-40">
          Empower Your Business with Our Mobile Application – Access, Manage,
          and Grow Anytime, Anywhere!
        </p>
        {/* Wrapper that allows scrolling */}
        <div className="px-  md:px-5 sm:px-3 grid grid-cols-1 md:grid-cols-1 lg:grid-cols-[2fr_1fr] gap-3 sm:gap-2 md:gap-8">
          {/* Main Content */}
          <div className="container mx-auto px-4 py-8">
            <div className="grid grid-cols-1 md:grid-cols-1 gap-8">
              {/* Image Section */}

              <div className="w-full md:order-1 order-2 max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
                <img
                  src={MobileApp}
                  alt="Mobile-application"
                  className="w-full h-full  object-cover"
                />
              </div>

              {/* Text Content Section */}
              <div className="space-y-2 md:text-base  text-sm order-2 md:order-1 text-justify">
                {/* <div class="max-w-4xl mx-auto p-6 space-y-8"> */}
                {/* <!-- Heading --> */}

                {/* </div> */}

                {/* Main Heading */}
                <h2 className="md:text-3xl text-xl font-bold text-main">
                  Transform Your Business with Mobile Apps
                </h2>

                {/* Introduction */}
                <p className="text-gray-600">
                  Smartphones have created a rage all around the globe and it
                  has overtaken the liking of laptops and desktops. As the
                  number of mobile users is accelerating, dynamic mobile
                  applications for your organization is the next thing to go for
                  promoting your business model to a wider range. We have
                  optimum experience in building and deploying android, windows,
                  and iPhone mobile applications.
                </p>
                <p className="text-gray-600">
                  The world is changing faster and so is the technology.
                  Technology has made it easier for people to access anything on
                  the internet via mobile phones by inventing smartphones. Now,
                  people feel better surfing anything and everything on the
                  phone rather than on a computer or laptop. Gone are the days,
                  when to open a website or to order something, you needed to
                  start your system and wait for getting the system started.
                </p>

                {/* Subheading: Business Growth */}
                <h2 className="md:text-2xl text-xl font-semibold text-main pt-4">
                  The Importance of Mobile Applications in Business Growth
                </h2>
                <p className="text-gray-600">
                  Mobile applications enable businesses to connect with their
                  customers anytime, anywhere. With features like real-time
                  updates, instant communication, and easy access to services,
                  mobile apps offer unparalleled convenience and engagement. Key
                  benefits include:
                </p>

                <ul className="list-disc list-inside space-y-2 text-gray-600">
                  <li>
                    <strong>Enhanced User Experience:</strong> Mobile apps
                    provide a smoother and more personalized experience than
                    traditional web platforms.
                  </li>
                  <li>
                    <strong>Increased Engagement:</strong> Push notifications,
                    direct messaging, and instant updates keep users engaged and
                    informed.
                  </li>
                  <li>
                    <strong>Better Accessibility:</strong> Available anytime and
                    anywhere, making it easier for users to interact with your
                    business.
                  </li>
                  <li>
                    <strong>Streamlined Operations:</strong> Simplify complex
                    business processes with custom mobile solutions for
                    inventory, booking, and more.
                  </li>
                </ul>

                {/* Subheading: Expertise */}
                <h2 className="text-2xl font-semibold text-main pt-4">
                  Our Expertise in Mobile Application Development
                </h2>

                <p className="text-gray-600">
                  We, at <span className="font-bold">Deetya Soft</span>, offer
                  services for mobile application development. Our motive is to
                  provide our client a complete solution starting from planning
                  to maintenance for mobile application that meets the
                  personalised requirement of their business. We always try our
                  level best to properly understand the needs of our clients and
                  suggesting them the most suitable facilities to them. We along
                  with our team fulfil your entire requirements regarding mobile
                  application development.
                </p>

                <p className="text-gray-600">
                  At <span className="font-bold">Deetya Soft</span>, we
                  specialize in crafting high-performance mobile applications
                  tailored to your business needs. From native applications for
                  iOS and Android to cross-platform solutions, we build apps
                  that are fast, secure, and scalable.
                </p>

                <p className="text-gray-600">
                  Security and performance are at the forefront of our
                  development. We integrate top-tier security protocols and
                  optimize app performance to ensure smooth operation, even
                  during peak usage. Whether you need real-time updates, payment
                  integrations, or advanced analytics, our team delivers
                  solutions that drive results.
                </p>

                {/* Closing Statement */}
                <p className="text-gray-600">
                  At <span className="font-bold">Deetya Soft</span>, we don't
                  just build mobile applications; we create seamless digital
                  experiences that empower your business. Let us help you
                  elevate your business with a mobile application that drives
                  growth, enhances customer satisfaction, and keeps you ahead of
                  the competition.
                </p>
              </div>
            </div>
          </div>
          {/* Sticky Sidebar */}
          <div className="sticky md:block hidden  top-20 self-start  p-3  h-fit">
            <ServiceSide />
          </div>
        </div>

        {/* make it next section */}

        <div
          className="py-5 px-5 relative"
          // data-aos='fade-up'
          style={{
            backgroundImage: `url(${BgImg})`,
            backgroundRepeat: "repeat",
            backgroundSize: "auto",
            backgroundPosition: "center",
            backgroundAttachment: "fixed",
            minHeight: "60vh",
          }}
        >
          <div className="text-center py-10 px-4">
            <h2 className="text-3xl md:text-4xl font-extrabold">
              <span className="text-black">Mobile Application</span>
              <span className="text-sky-500"> Feature</span>
            </h2>

            <div className="relative w-fit mx-auto mt-2">
              <div className="h-[1px] bg-gray-400 md:w-[200px] w-[100px] mx-auto"></div>
              <div className="absolute left-1/2 -translate-x-1/2 -top-[1px] flex gap-2">
                <div className="w-8 h-[2px] bg-sky-500"></div>
                <div className="w-8 h-[2px] bg-sky-500"></div>
              </div>
            </div>

            <p className="text-gray-800 text-base mt-4">
              What You Get Using Our In Mobile Application
            </p>
          </div>

          {/* features section */}

          <div className="container mx-auto px-4 pb-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {pillars.map((pillar, index) => (
                <div
                  key={index}
                  data-aos="fade-up" // Add AOS fade-up animation
                  className="bg-gray-50 shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
                >
                  <div className="p-8 text-center">
                    <div
                      className={`w-16 h-16 flex items-center justify-center rounded-full ${pillar.bgColor} mb-4 mx-auto`}
                    >
                      <FontAwesomeIcon
                        icon={pillar.icon}
                        className="text-sky-500 text-2xl"
                      />
                    </div>
                    <h5 className="md:text-lg text-base font-semibold text-gray-800 mb-3">
                      {pillar.title}
                    </h5>
                    <p className="text-gray-600 text-sm">
                      {pillar.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div id="bottomTarget">
          {/* benifits section is here */}
          <MobileApplicationFaq />
        </div>
      </div>
    </>
  );
};

export default MobileApplication;

// <div
//       className="relative h-auto md:h-[65vh] lg:h-[80vh] bg-gradient-to-r from-blue-400 to-indigo-50 py-8 md:py-10 overflow-hidden"
//       data-aos="fade-up"
//     >
//       {/* Decorative Circles */}
//       <div
//         className="hidden md:block absolute w-[300px] h-[300px] bg-white/10 rounded-full top-[10%] left-[5%] z-10"
//         data-aos="zoom-in"
//       ></div>
//       <div
//         className="absolute w-[300px] h-[300px] bg-white/10 rounded-full bottom-[15%] right-[10%] z-10"
//         data-aos="zoom-in"
//       ></div>

//       <div className="container mx-auto px-6 relative z-10">
//         <div className="flex flex-col lg:flex-row items-center">
//           {/* Left Text */}
//           <div
//             className="lg:w-1/2 text-center lg:text-left"
//             data-aos="fade-right"
//           >
//             <h1 className="text-3xl md:text-5xl font-bold text-gray-800">
//               Mobile Application
//             </h1>
//             <p className="mt-2 text-base md:text-lg text-black">
//               We offer a wide range of web solutions tailored to your business
//               needs. From designing modern, responsive websites to
//               implementing advanced web technologies, we ensure your online
//               presence is impactful and user-friendly. Our team is committed
//               to delivering scalable and future-ready digital experiences that
//               drive results.
//             </p>
//           </div>

//           {/* Right Image */}
//           <div
//             className="lg:w-1/2 flex justify-center mt-8 lg:mt-0"
//             data-aos="fade-left"
//           >
//             <img
//               src={MobileHero}
//               alt="Mobile-application"
//               className="w-[65%] max-w-lg animate-float"
//             />
//           </div>
//         </div>
//       </div>
//     </div>
